import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class TrackBlock extends Component {
  static propTypes = {
    price: PropTypes.number,
    reservation: PropTypes.object,
  };

  componentDidMount() {
    const { price, reservation } = this.props;
    if (reservation && reservation.offer && price !== null) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        ecommerce: {
          checkout: {
            actionField: {
              step: 'booking_street'
            },
            products: [
              {
                name: `${reservation.offer.kind_name}`,
                id: `${reservation.offer.object_name}`,
                price: `${parseFloat(price)}`,
                category: `${reservation.criteria.special_code == null ? 'no special code' : reservation.criteria.special_code}`,
                quantity: 1
              }
            ]
          }
        },
        event: 'ecomCheckout'
      });
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  price: state.reservation.total_price,
  reservation: state.reservation,
});

export default connect(
  mapStateToProps
)(TrackBlock);
